module.exports = __webpack_public_path__ + "img/icon-add-user.05dbdb6d.svg";